import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import {
  _COALESCED_STYLE_SCHEDULER,
  _CoalescedStyleScheduler,
  CDK_TABLE,
  CdkTable,
  CdkTableModule,
} from '@angular/cdk/table';
import { _DisposeViewRepeaterStrategy, _VIEW_REPEATER_STRATEGY } from '@angular/cdk/collections';

@Component({
  selector: 'table[issTable]', // eslint-disable-line @angular-eslint/component-selector
  exportAs: 'issTable',
  templateUrl: './table.component.html',
  providers: [
    // @ts-ignore
    { provide: CdkTable, useExisting: TableComponent },
    // @ts-ignore
    { provide: CDK_TABLE, useExisting: TableComponent },
    { provide: _COALESCED_STYLE_SCHEDULER, useClass: _CoalescedStyleScheduler },
    {
      provide: _VIEW_REPEATER_STRATEGY,
      useClass: _DisposeViewRepeaterStrategy,
    },
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Default,
  host: { // eslint-disable-line @angular-eslint/no-host-metadata-property
    class: 'iss-table table is-hoverable is-fullwidth',
    '[class.iss-table-loading]': 'loading',
    '[class.iss-table-inverted]': 'inverted',
  },
  standalone: true,
  imports: [
    CdkTableModule,
    NgIf,
    NgFor,
  ],
})
// @ts-ignore
export class TableComponent<T> extends CdkTable<T> implements OnInit {
  public loadingRows: unknown[] = Array(10);

  @Input() public loading?: boolean | null;
  @Input() public inverted?: boolean | null;
}
